export default __webpack_public_path__ + "static/media/Sofia Pro Semi Bold Az.20448924.otf";